<template lang="pug">
  .arrow
    img(src="@/assets/arrow-white.svg")
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
  .arrow{
    width: 6px;
    img{
      width: 100%;

    }
  }
</style>

